(function(itxApp) {
    'use strict';


    angular.module('itxApp.common').filter('tCms', ['CmsConfigSvc', ItxTranslateFlt]);

    function ItxTranslateFlt(CmsConfigSvc) {
        var cache = {};

        function flt(value, replace) {
            if (cache[value]) {
                if (replace) {
                    return CmsConfigSvc.replaceParamsOnTranslation(cache[value].value, replace);
                }
                return cache[value].value;
            }
            if (!cache[value]) {
                cache[value] = { isWaiting: false };
            }
            if (!cache[value].isWaiting) {

                CmsConfigSvc.getTranslation(value,[]).then(function(res) {
                    cache[value].isWaiting = true;

                    cache[value].value = res;
                    
                });
            }
        }
        flt.$stateful = true;
        return flt;
    }
    
})();